import { render, staticRenderFns } from "./ProjectsBOM.vue?vue&type=template&id=5c8a6bf5&"
import script from "./ProjectsBOM.vue?vue&type=script&lang=js&"
export * from "./ProjectsBOM.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsBOM.vue?vue&type=style&index=0&id=5c8a6bf5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports